import { FC } from 'react';
import { connect } from 'react-redux';
import Text, { TextPresets } from '@stripcash/ui-kit/components/Text';

import ContentWrapper from 'common/components/ContentWrapper';
import ErrorNavigation from 'common/components/ErrorNavigation';
import { isUserLoggedInSelector } from 'users/selectors';
import MetaTags from 'common/components/MetaTags';
import { AuthPartialState } from 'users/reducers/auth';

import styles from './styles.module.css';

type ForbiddenPagePropTypes = {
  isLoggedIn: boolean;
};

const ForbiddenPage: FC<ForbiddenPagePropTypes> = ({ isLoggedIn }) => (
  <ContentWrapper className={styles.forbiddenPage}>
    <MetaTags title="404 - Page not found | Webcams Affiliate Program | Stripcash" />
    <Text preset={TextPresets.H1}>403</Text>
    <Text preset={TextPresets.H2}>Access forbidden</Text>
    <p>You are not allowed to access this page.</p>
    <div className={styles.navWrapper}>
      <ErrorNavigation isLoggedIn={isLoggedIn} />
    </div>
  </ContentWrapper>
);

export default connect((state) => ({
  isLoggedIn: isUserLoggedInSelector(state as AuthPartialState),
}))(ForbiddenPage);
